export const ERROR_MESSAGES = {
    PAYMENT_BLOCK: 'Fábrica bloqueada por falta de pagamento',
}
